import { Component, Input, Output, OnInit, forwardRef, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-textarea',
  templateUrl: './form-textarea.component.html',
  styleUrls: ['./form-textarea.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormTextareaComponent),
      multi: true
    }
  ]
})
export class FormTextareaComponent implements OnInit, ControlValueAccessor {
  @Input()  required = false;
  @Input()  name = '';
  @Input()  placeholder = '';
  @Input()  maxlength = 1000;
  @Input()  rows;
  @Output() contentChange: EventEmitter<any>;

  public content = '';

  propagateChange = (_: any) => {};

  constructor() {
    this.contentChange = new EventEmitter();
  }

  ngOnInit() {
  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.content = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  onContentChange(content) {
    this.propagateChange(content);
    this.contentChange.emit(content);
  }

  getRemainingChars() {
    return this.maxlength - (this.content || '').length;
  }
}
